import Api from 'services/Api'
import { createErrorNotification } from './notifications'

export function setPlateform(platform) {
  return dispatch => dispatch({ type: 'SET_PLATEFORM', platform })
}

/**
 * Function to fetch the shifts the user needs to confirm
 */
export function fetchShiftsToConfirm() {
  return async (dispatch, getState) => {
    const { userId } = getState()
    dispatch({ type: 'SET_IS_LOADING_SHIFTS_TO_CONFIRM' })
    const { result, success } = await Api('/schedule/confirm', { params: { userId, useNewReturn: true } })
    if (!success) return dispatch(createErrorNotification())
    // Set only if we have some shifts to confirm
    if (result.length) dispatch({ type: 'SET_SHIFT_TO_CONFIRM', shiftsToConfirm: result })
    dispatch({ type: 'SET_SHIFTS_TO_CONFIRM_ALL_LOADED' })

    return result
  }
}

export function removeShiftsToConfirm() {
  return dispatch => dispatch({ type: 'REMOVE_SHIFTS_TO_CONFIRM' })
}

/**
 * Function to fetch the attribute reminder the user needs to confirm
 */
export function fetchAttributeReminderToConfirm() {
  return async dispatch => {
    dispatch({ type: 'SET_IS_LOADING_ATTRIBUTE_REMINDER_TO_CONFIRM' })
    const { result, success } = await Api(`/attributes/contact/events`, { params: { status: 'pendingConfirmation' } })
    if (!success) return dispatch(createErrorNotification())
    // Set only if we have an attribute expiration reminder to confirm and requireAcknowledgement is true
    const attributeRemindersToConfirm = result
      .map(item => {
        if (item?.reminders?.length > 0) {
          const remindersWithNotificationEnabled = item.reminders.filter(reminder => !!reminder?.requireAcknowledgement)

          if (remindersWithNotificationEnabled.length > 0) {
            return { ...item, reminders: remindersWithNotificationEnabled }
          }
        }
      })
      .filter(Boolean)

    if (attributeRemindersToConfirm.length) dispatch({ type: 'SET_ATTRIBUTE_REMINDER_TO_CONFIRM', attributeReminderToConfirm: attributeRemindersToConfirm })

    dispatch({ type: 'SET_ATTRIBUTE_REMINDER_TO_CONFIRM_ALL_LOADED' })
  }
}

export function removeAttributeReminderToConfirm() {
  return dispatch => dispatch({ type: 'REMOVE_ATTRIBUTE_REMINDER_TO_CONFIRM' })
}
